const e = "_wrapper_1jbci_1", n = "_innerWrapper_1jbci_5", t = "_headingWrapper_1jbci_15", a = "_bookingDetails_1jbci_21", r = "_label_1jbci_38", p = "_details_1jbci_42", _ = "_buttonWrapper_1jbci_50", c = "_cancelButton_1jbci_61", i = {
  wrapper: e,
  innerWrapper: n,
  headingWrapper: t,
  bookingDetails: a,
  label: r,
  details: p,
  buttonWrapper: _,
  cancelButton: c
};
export {
  a as bookingDetails,
  _ as buttonWrapper,
  c as cancelButton,
  i as default,
  p as details,
  t as headingWrapper,
  n as innerWrapper,
  r as label,
  e as wrapper
};
